import React from 'react';
import { Segment } from 'semantic-ui-react';
import GlassmorphismTheme from '../../styles/glassmorphism';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const ChartCard: React.FC<ChartCardProps> = ({ title, subtitle, children, style }) => {
  return (
    <Segment
      style={{
        ...GlassmorphismTheme.components.glassCard,
        padding: '20px',
        marginBottom: GlassmorphismTheme.spacing.lg,
        background: '#ffffff',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        ...style,
      }}
    >
      <div style={{ marginBottom: GlassmorphismTheme.spacing.md }}>
        <h3 style={{ 
          color: GlassmorphismTheme.colors.solid.text, 
          margin: 0,
          fontSize: '1.2rem',
          fontWeight: 600
        }}>
          {title}
        </h3>
        {subtitle && (
          <p style={{ 
            color: GlassmorphismTheme.colors.solid.textLight, 
            margin: '4px 0 0 0',
            fontSize: '0.9rem'
          }}>
            {subtitle}
          </p>
        )}
      </div>
      {children}
    </Segment>
  );
};

export default ChartCard;

